import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';

@Injectable({
    providedIn: 'root'
})
export class EmergencyNotificationService {

    private subject = new BehaviorSubject<string>('Initial Value')
    current = this.subject.asObservable()

    private arrayData = new BehaviorSubject([])
    currentArray = this.arrayData.asObservable()

    constructor(
        private router: Router,
        private http: HttpClient
    ) { }

    emergencytemplatesLists(search: any, page: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/list?search=` + search + '&page=' + page).pipe(map(user => user));
    }

    createAlert(heading: any, message: any, alertType: any, apartmentId: any, createdBy: any) {
        const formData = {
            heading: heading,
            message: message,
            alertType: alertType,
            createdBy: createdBy,
            apartmentId: [apartmentId]
        };
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/create`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updateAlert(id: any, heading: any, message: any, alertType: any, apartmentId: any, createdBy: any,status:any) {
        const formData = {
            heading: heading,
            message: message,
            alertType: alertType,
            apartmentId: [apartmentId],
            createdBy: createdBy,
            status:status
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/update/${id}`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    deleteAlert(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    getAlertbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/getById/${id}`).pipe(map(user => user));
    }

    sendAlert(templateId:any,apartmentIds: string[]) {
      
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/send`,{templateId:templateId,apartmentId:apartmentIds}).pipe(map(user => user));
    }

    getActiveAlert(page: any,search: any, status:any,type:any,apartmentId:any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/list-active-alerts?search=` + search + '&page=' + page+ '&status=' + status+'&alertType='+type+'&apartmentId='+apartmentId).pipe(map(user => user));
    }

    // SOS raised by residents (GET /apartment/sos/list) — category has '&', so it is URL-encoded
    getSosList(page: any, status: any, category: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/sos/list?page=` + page + '&status=' + status + '&category=' + encodeURIComponent(category)).pipe(map(user => user));
    }

    // How many SOS are still PENDING for this apartment (drives the siren in the header)
    getSosPendingCount() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/sos/pending-count`).pipe(map(user => user));
    }

    // PENDING | ACKNOWLEDGED | HELP_ON_THE_WAY | RESOLVED | CANCELLED
    updateSosStatus(id: any, status: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/apartment/sos/update-status/${id}`, { status }).pipe(map(user => user));
    }

    getActiveAlertResponse(id:any,search:any,status:any,page:any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/get-responses/${id}?search=` + search+'&response='+status+'&page='+page ).pipe(map(user => user));
    }

    downloadResponsesExcel(id:any) {
        const file = this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/responses-excel/${id}`, { responseType: 'blob' as 'json' }).pipe(map(user => {
            return user
        }));
        return file;
    }

    responseSummary(id:any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/response-summary/${id}`).pipe(map(user => {
            return user
        }));
    }

    updateAlertstatus(id: any) {
        
       
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/emergency-notif/close-alert/${id}`,
                {}
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    addFloorMapping(formData: any) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/floorMapping/add`, formData).pipe(map(user => user));
    }

    getFloorMappings() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/floorMapping/list`).pipe(map(user => user));
    }

    getFloorMappingsByApartment(page: any, apartmentId: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/floorMapping/list?id=` + apartmentId + '&page=' + page).pipe(map(user => user));
    }

    getFloorMappingById(floorId: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/floor-mapping/${floorId}`);
    }

    updateFloorMapping(floorId: string, formData: FormData) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/floorMapping/update/${floorId}`, formData);
    }

    deleteFloorMapping(floorId: string) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/floorMapping/delete/${floorId}`);
    }
}
